import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnumToSelectButton = _resolveComponent("EnumToSelectButton")

  return (_openBlock(), _createBlock(_component_EnumToSelectButton, {
    modelValue: _ctx.actionToAdd.sceneShutterState,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.actionToAdd.sceneShutterState = $event)),
    class: "mb-5",
    enum: _ctx.SceneShutterState
  }, null, 8, ["modelValue", "enum"]))
}